/**
 * Doctor Recipe API - Main Export File
 * Provides a unified API object that combines recipe, ingredients, and steps APIs
 * This maintains backward compatibility with existing code
 */

import * as recipeOperations from './recipeApi';
import * as ingredientsOperations from './ingredientsApi';
import * as stepsOperations from './stepsApi';

/**
 * Combined API object for backward compatibility
 * Use individual APIs (recipeOperations, ingredientsOperations, stepsOperations) for better organization
 */
export const recipeApi = {
  // Recipe operations
  getAllRecipes: recipeOperations.getAllRecipes,
  getRecipeById: recipeOperations.getRecipeById,
  createRecipe: recipeOperations.createRecipe,
  updateRecipe: recipeOperations.updateRecipe,
  updateRecipeScope: recipeOperations.updateRecipeScope,
  setRecipeReady: recipeOperations.setRecipeReady,
  deleteRecipe: recipeOperations.deleteRecipe,
  submitForReview: recipeOperations.submitForReview,
  getApprovedRecipes: recipeOperations.getApprovedRecipes,
  getParentRecipeOptions: recipeOperations.getParentRecipeOptions,

  // Ingredient operations
  getRecipeIngredients: ingredientsOperations.getRecipeIngredients,
  saveRecipeIngredients: ingredientsOperations.saveRecipeIngredients,
  updateRecipeIngredient: ingredientsOperations.updateRecipeIngredient,
  deleteRecipeIngredient: ingredientsOperations.deleteRecipeIngredient,
  reorderRecipeIngredients: ingredientsOperations.reorderRecipeIngredients,

  // Step operations
  getRecipePreparationSteps: stepsOperations.getRecipePreparationSteps,
  saveRecipePreparationStep: stepsOperations.saveRecipePreparationStep,
  updateRecipePreparationStep: stepsOperations.updateRecipePreparationStep,
  deleteRecipePreparationStep: stepsOperations.deleteRecipePreparationStep,

  // Common mistakes
  addCommonMistake: recipeOperations.addCommonMistake,

  // Lifecycle operations
  revertRecipe: recipeOperations.revertRecipe,
  archiveRecipe: recipeOperations.archiveRecipe,
  getRecipeActivityLogs: recipeOperations.getRecipeActivityLogs,
  takeBackRecipe: recipeOperations.takeBackRecipe,
};

// Export individual APIs for better organization
export * as recipeOperations from './recipeApi';
export * as ingredientsOperations from './ingredientsApi';
export * as stepsOperations from './stepsApi';

// Export types
export * from './types';

// Export helpers and transformers if needed
export * from './helpers';
export * from './transformers';
